
let otpTimerInterval;

function verifyOTP() {
  const otpLoginDisableButton = document.getElementById('verify-otp-btn');
  // Disable
  otpLoginDisableButton.classList.add('disabled');
  const email = document.getElementById("otp-email").value.trim();
  const otp1 = document.getElementById("otp1").value;
  const otp2 = document.getElementById("otp2").value;
  const otp3 = document.getElementById("otp3").value;
  const otp4 = document.getElementById("otp4").value;

  const otp = otp1 + otp2 + otp3 + otp4;
  const otpNumber = document.querySelector('.otp-number-error_message');

  if (!otp || otp.length < 4) {
    otpNumber.textContent = 'codice non valido, si prega di provare di nuovo';
    const otpLoginDisableButton = document.getElementById('verify-otp-btn');
    otpLoginDisableButton.classList.remove('disabled');
    addDangerBorder()
    return;
  }

  fetch("https://cpanel.comfortclick.co.uk/shopify/verifyOTPLogin", {
  // fetch("https://a9e1c6cfd558.ngrok-free.app/api/verifyotp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      otp: otp,
      domain_id: '28',
      shop_name: 'weightworld-it',
    }),
  }).then(response => {
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }
    return response.json();
  }).then(data => {
    console.log("data", data);
    if (data.status == "SUCCESS") {
      const otpNumber = document.querySelector('.otp-number-error_message');
      otpNumber.classList.add('hidden')
      removeDangerBorder()
      document.querySelector('#social_login_email').value = email;
      document.querySelector('#social_login_password').value = data.password;
      document.querySelector('.social_login_form').submit();
    } else if (data.status == "USER_NOT_EXIST") {
      alert(data.message);
      const otpLoginDisableButton = document.getElementById('verify-otp-btn');
      otpLoginDisableButton.classList.remove('disabled');
    } else if (data.status == "OTP_ERROR") {
      const otpNumber = document.querySelector('.otp-number-error_message');
      const otpLoginDisableButton = document.getElementById('verify-otp-btn');
      otpLoginDisableButton.classList.remove('disabled');
      showOtpErrorAlert()
      otpNumber.textContent = data.message;
      addDangerBorder()
    } else {
      const otpLoginDisableButton = document.getElementById('verify-otp-btn');
      otpLoginDisableButton.classList.remove('disabled');
      alert("Something went wrong");
    }
  }).catch(error => {
    console.error("Error:", error);
    alert("Something went wrong");
  });
}


function generateOTP() {
  const email = document.getElementById("otp-email").value.trim();
  const errorMessage = document.querySelector(".otp-error_message");
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const btn = document.getElementById('generate-otp-btn');
  btn.style.opacity = '0.5';

  setTimeout(() => {
    btn.style.opacity = '1';
  }, 2000);


  // Validate empty email
  if (!email) {
    errorMessage.textContent = "Per favore inserisci la tua email";
    return;
  }

  // Validate invalid email format
  if (!emailPattern.test(email)) {
    errorMessage.textContent = "Per favore, inserisci un Indirizzo e-mail valido.";
    return;
  }

  errorMessage.textContent = "";

  // Fetch call only if email is valid
  fetch("https://cpanel.comfortclick.co.uk/shopify/signInWithOtp", {
  // fetch("https://a9e1c6cfd558.ngrok-free.app/api/otplogin", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email: email,
      domain_id: "28",
      shop_name: "weightworld-it",
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "SUCCESS") {
        document.querySelector(".verify-otp_button").classList.remove("hidden");
        document.querySelector("#generate-otp-btn").classList.add("hidden");
        // Start a NEW timer after successful OTP generation
        startOTPTimer();

      } else if (data.status === "NOT_FOUND") {
        const alertBox = document.getElementById("emailnotreg");
        alertBox.classList.remove('hidden');
        showEmailNotRegisteredAlert()
      } else {
        console.log("data", data);
        alert("Something went wrong");
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("Something went wrong");
    });
}


function addDangerBorder() {
  const otpFields = document.querySelectorAll('.otpField');
  otpFields.forEach(field => {
    field.classList.add('border-danger');
  });
}

// Remove red border from all .otpField inputs
function removeDangerBorder() {
  const otpFields = document.querySelectorAll('.otpField');
  otpFields.forEach(field => {
    field.classList.remove('border-danger');
  });
}


function showEmailNotRegisteredAlert() {
  const alertBox = document.getElementById("emailnotreg");
  alertBox.classList.remove('hidden')
}

function showOtpErrorAlert() {
  const alertBox = document.querySelector(".otp-error-card");
  alertBox.classList.remove('hidden')
}

document.querySelectorAll(".register-alert-close").forEach(closeBtn => {
  closeBtn.addEventListener("click", () => {
    const alertBox = closeBtn.closest(".alert");
    if (alertBox) {
      alertBox.classList.add("hidden");
    }
  });
});


function startOTPTimer() {
  // Clear any existing timer to ensure a clean restart
  if (otpTimerInterval) {
    clearInterval(otpTimerInterval);
    otpTimerInterval = null;
  }

  let timeLeft = 5 * 60;
  const timerDisplay = document.getElementById("otp-timer");
  const resendOtpButton = document.querySelector(".resend-otp-button");
  const otpButtonText = document.querySelector(".otp-button_text");

  resendOtpButton.classList.add("hidden");
  otpButtonText.classList.remove("hidden");
  timerDisplay.textContent = "05:00";

  // Start the new interval
  otpTimerInterval = setInterval(() => {
    if (timeLeft <= 0) {
      clearInterval(otpTimerInterval);
      otpTimerInterval = null; // Clear the interval ID
      timerDisplay.textContent = "";
      resendOtpButton.classList.remove("hidden");
      otpButtonText.classList.add("hidden");
    } else {
      timeLeft--;
      const minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
      const seconds = String(timeLeft % 60).padStart(2, "0");
      timerDisplay.textContent = `${minutes}:${seconds}`;
    }
  }, 1000);
}


// OTP input auto-focus logic
document.addEventListener("DOMContentLoaded", () => {
  const otpInputs = document.querySelectorAll(".otpField");
  otpInputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
      if (e.target.value && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
      }
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" && !e.target.value && index > 0) {
        otpInputs[index - 1].focus();
      }
    });
  });
});


const otpLoginButton = document.getElementById('otp-login-button');
const passwordLoginButton = document.getElementById('password-login-button');

// Function to show the OTP login section
function showOtpLoginSection() {
  document.querySelector('.login-container.grid__item').classList.add('hidden');
  document.querySelector('.otp-login-container').classList.remove('hidden');
  document.querySelector('#generate-otp-btn').classList.remove('hidden');
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

if (otpLoginButton) {
  otpLoginButton.addEventListener('click', showOtpLoginSection);
}

if (passwordLoginButton) {
  passwordLoginButton.addEventListener('click', () => {
    document.querySelector('.login-container.grid__item').classList.remove('hidden')
    document.querySelector('.otp-login-container').classList.add('hidden')
    // document.querySelector(".verify-otp_button").classList.add("hidden");

    if (otpTimerInterval) {
      clearInterval(otpTimerInterval);
      otpTimerInterval = null;

      document.querySelector(".resend-otp-button").classList.remove("hidden");
      document.querySelector(".otp-button_text").classList.add("hidden");
      document.getElementById("otp-timer").textContent = "";
    }
  })
}